// extracted by mini-css-extract-plugin
export default {"break-point-md":"40rem","break-point-lg":"60rem","arrows":"Arrows_arrows__dlpKM"};